// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__Usg+l","content":"PageLayout_content__DR0J9"};